export const ANALYTICS_EVENTS: Record<string, string> = {
  CHECKOUT_STARTED: 'checkout_started',
  REMOVE_FROM_CART: 'remove_from_cart',
};
